export enum FccDefaultTags {
    PCC = 'pcc',
    IMAGE = 'image',
    IMAGE2 = 'image2'
}
